import type { AnnotationState } from '../../generated';
import { ReactiveMap } from '../../utils/ReactiveMap';
import { ReactiveState } from '../../utils/ReactiveState';

export const ANNOTATION_STATE_DEFAULTS: AnnotationState = {
  __typename: `AnnotationState`,
  annotations: [],
  assetId: null,
  id: 'draft-annotation',
  isActive: false,
  lastUpdated: 0,
  selectedTool: 'pen',
  selectedColor: 'var(--colors-meta-opaque-orange)',
};

export const state = {
  selected: new ReactiveState<{ id: string }>(null),
  drafts: new ReactiveMap<string, AnnotationState>(),
};
